/**
 * Viewport entrance for collection intro (eyebrow, heading, subtext).
 * Geometry-based threshold so tall blocks still reveal; prefers-reduced-motion reveals immediately.
 */
(function () {
  var SEL = '.collection-intro--reveal';

  function revealApi() {
    return window.R3NU && window.R3NU.reveal ? window.R3NU.reveal : null;
  }

  function shouldRevealGeometry(el, entry) {
    var api = revealApi();
    if (api) return api.shouldReveal(el, entry);
    return entry && entry.isIntersecting;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function detachListeners(root) {
    if (root._collectionIntroRevealIO) {
      root._collectionIntroRevealIO.disconnect();
      root._collectionIntroRevealIO = null;
    }
    if (root._collectionIntroRevealOnScroll) {
      window.removeEventListener('scroll', root._collectionIntroRevealOnScroll, { capture: true });
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', root._collectionIntroRevealOnScroll);
      }
      root._collectionIntroRevealOnScroll = null;
    }
    if (root._collectionIntroRevealOnResize) {
      window.removeEventListener('resize', root._collectionIntroRevealOnResize);
      root._collectionIntroRevealOnResize = null;
    }
  }

  function reveal(root) {
    root.classList.add('collection-intro--revealed');
    detachListeners(root);
  }

  function teardown(root) {
    detachListeners(root);
  }

  function init(root) {
    if (!root || root.dataset.collectionIntroRevealInit) return;
    root.dataset.collectionIntroRevealInit = 'true';

    if (prefersReducedMotion()) {
      reveal(root);
      return;
    }

    if (root.classList.contains('collection-intro--revealed')) return;

    var api = revealApi();
    var rootMargin = api ? api.getRootMargin() : '0px 0px 12% 0px';
    var thresholdList = api ? api.buildThresholdList() : [0, 0.1, 0.2, 0.5, 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          if (shouldRevealGeometry(root, entry)) reveal(root);
        });
      },
      { threshold: thresholdList, rootMargin: rootMargin }
    );
    io.observe(root);
    root._collectionIntroRevealIO = io;

    function onResize() {
      if (root.classList.contains('collection-intro--revealed')) return;
      if (shouldRevealGeometry(root, null)) reveal(root);
    }
    root._collectionIntroRevealOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    function onScrollRaf() {
      if (root.classList.contains('collection-intro--revealed')) return;
      requestAnimationFrame(function () {
        if (root.classList.contains('collection-intro--revealed')) return;
        try {
          if (root._collectionIntroRevealIO) {
            root._collectionIntroRevealIO.takeRecords().forEach(function (entry) {
              if (entry.target === root && shouldRevealGeometry(root, entry)) reveal(root);
            });
          }
        } catch (e) {}
        if (!root.classList.contains('collection-intro--revealed') && shouldRevealGeometry(root, null)) {
          reveal(root);
        }
      });
    }
    root._collectionIntroRevealOnScroll = onScrollRaf;
    window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScrollRaf, { passive: true });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('collection-intro--revealed')) return;
        if (shouldRevealGeometry(root, null)) reveal(root);
      });
    });
  }

  function destroy(root) {
    delete root.dataset.collectionIntroRevealInit;
    teardown(root);
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var el = t.matches && t.matches(SEL) ? t : t.querySelector(SEL);
    if (el) destroy(el);
  });

  function syncCollectionIntroInView() {
    document.querySelectorAll(SEL).forEach(function (root) {
      if (!root.dataset.collectionIntroRevealInit) return;
      if (root.classList.contains('collection-intro--revealed')) return;
      var io = root._collectionIntroRevealIO;
      if (io) {
        try {
          io.takeRecords().forEach(function (entry) {
            if (entry.target === root && shouldRevealGeometry(root, entry)) reveal(root);
          });
        } catch (e) {}
      }
      if (root.classList.contains('collection-intro--revealed')) return;
      if (shouldRevealGeometry(root, null)) {
        reveal(root);
      }
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncCollectionIntroInView);
  }
})();
